import {
  Card, Collapse, Row, Form, Col, Input, DatePicker, Cascader, InputNumber, Select,
} from 'antd';
import { any } from 'prop-types';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

function SubjectBasicInfo({ area, data, dict }) {
  const { state: passedState } = useLocation();
  // 禁用今天之后的日期
  const disabledDate = (current) => current && current.isAfter(moment().endOf('day'));
  const year = passedState?.year || data?.declarationYear;

  return (
    <Card title="申报主体信息" className="form-info__box">
      <Collapse defaultActiveKey={['1-1']}>
        <Collapse.Panel key="1-1" header="申报主体基本信息">
          <Row>
            <Col span={11}>
              <Form.Item
                name="applicantName"
                label="企业名称"
                rules={[
                  {
                    required: true,
                    message: '企业名称',
                  },
                  { pattern: /^\s*\S.*$/, message: '企业名称' },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col span={13}>
              <Form.Item
                name="applicantNo"
                label="统一社会信用代码"
                rules={[
                  {
                    required: true,
                    message: '统一社会信用代码',
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col span={11}>
              <Form.Item
                name="registrationTime"
                label="注册时间"
                rules={[
                  {
                    required: true,
                    message: '请选择注册时间',
                  },
                ]}
              >
                <DatePicker style={{ width: '100%' }} disabledDate={disabledDate} />
              </Form.Item>
            </Col>

            <Col span={13}>
              <Form.Item
                name={['ignore', 'registrationLocation']}
                label="注册地点"
                rules={[
                  {
                    required: true,
                    message: '请选择项注册地点',
                  },
                ]}
              >
                <Cascader
                  options={area}
                  placeholder="请选择项注册地点"
                  fieldNames={{ label: 'name', value: 'id', children: 'children' }}
                />
              </Form.Item>
            </Col>

            <Col span={11}>
              <Form.Item
                name="registeredCapital"
                label="注册资本"
                rules={[
                  {
                    required: true,
                    message: '请输入注册资本（万元）',
                  },
                ]}
              >
                <InputNumber
                  placeholder="请输入注册资本（万元）"
                  addonAfter="万元"
                  min={0}
                  max={99999999}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>

            <Col span={13}>
              <Form.Item
                name="mainProduct"
                label="主要产品"
                rules={[
                  {
                    required: true,
                    message: '请输入主要产品',
                  },
                ]}
              >
                <Input placeholder="请输入主要产品" />
              </Form.Item>
            </Col>

            <Col span={11}>
              <Form.Item
                name="legalRepresentative"
                label="法人代表"
                rules={[
                  {
                    required: true,
                    message: '请输入法人代表',
                  },
                ]}
              >
                <Input placeholder="请输入法人代表" />
              </Form.Item>
            </Col>

            <Col span={13}>
              <Form.Item
                name="contactPerson"
                label="联系人"
                rules={[
                  {
                    required: true,
                    message: '请输入联系人',
                  },
                ]}
              >
                <Input placeholder="请输入联系人" />
              </Form.Item>
            </Col>

            <Col span={11}>
              <Form.Item
                name="contactPhone"
                label="联系电话"
                rules={[
                  {
                    required: true,
                    message: '请输入联系电话',
                  },
                  { pattern: /(^1[3-9]\d{9}$)|(^(\d{3,4}-?|\d{3,4}\))?\d{7,8}$)/, message: '电话号码格式错误' },
                ]}
              >
                <Input placeholder="请输入联系电话" />
              </Form.Item>
            </Col>

            <Col span={13}>
              <Form.Item
                name="contactAddress"
                label="联系地址"
                rules={[
                  {
                    required: true,
                    message: '请输入联系地址',
                  },
                ]}
              >
                <Input placeholder="请输入联系地址" />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item
                name="employeesNumber"
                label={`${year - 1}年度职工人数`}
                rules={[
                  {
                    required: true,
                    message: '请输入职工人数',
                  },
                ]}
              >
                <InputNumber
                  placeholder="请输入职工人数"
                  addonAfter="人"
                  min={0}
                  max={99999999}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                name="operatingIncome"
                label={`${year - 1}年度营业收入`}
                rules={[
                  {
                    required: true,
                    message: '请输入营业收入',
                  },
                ]}
              >
                <InputNumber
                  placeholder="请输入营业收入"
                  addonAfter="万元"
                  min={0}
                  max={99999999}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>

            <Col span={11}>
              <Form.Item
                name="grossProfit"
                label={`${year - 1}年利润总额`}
                rules={[
                  {
                    required: true,
                    message: '请输入利润总额',
                  },
                ]}
              >
                <InputNumber
                  placeholder="请输入利润总额"
                  addonAfter="万元"
                  max={99999999}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                name="liabilitiesQuota"
                label={`${year - 1}年负债总额`}
                rules={[
                  {
                    required: true,
                    message: '请输入负债总额',
                  },
                ]}
              >
                <InputNumber
                  placeholder="请输入负债总额"
                  addonAfter="万元"
                  min={0}
                  max={99999999}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item
                name="assetsQuota"
                label={`${year - 1}年资产总额`}
                rules={[
                  {
                    required: true,
                    message: '请输入资产总额',
                  },
                ]}
              >
                <InputNumber
                  placeholder="请输入资产总额"
                  addonAfter="万元"
                  min={0}
                  max={99999999}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                name="fixedQuota"
                label="(其中：固定资产)"
              >
                <InputNumber
                  placeholder="请输入固定资产"
                  addonAfter="万元"
                  min={0}
                  max={99999999}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item
                label="企业类型"
                name="enterType"
                rules={[
                  {
                    required: true,
                    message: '请选择企业类型',
                  },
                ]}
              >
                <Select
                  placeholder="请选择企业类型"
                  options={dict?.specialEnterType || []}
                  fieldNames={{ label: 'name', value: 'val' }}
                />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Form.Item
                name="remark"
                label="备注"
              >
                <Input.TextArea maxLength={1000} showCount placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </Card>

  );
}

SubjectBasicInfo.propTypes = {
  area: any,
  data: any,
  dict: any,
};

export default SubjectBasicInfo;
